module.exports = __webpack_public_path__ + "img/12.3d78a104.png";